import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "header",
  id: "projects"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "filter" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "iconcategory" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "header" }
const _hoisted_9 = { class: "iconcont" }
const _hoisted_10 = ["src"]
const _hoisted_11 = ["innerHTML", "onClick"]
const _hoisted_12 = { class: "langs" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ic = _resolveComponent("ic")!
  const _component_Languages = _resolveComponent("Languages")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('cv.projects')), 1),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (category, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["category", { active: _ctx.activecategory === index }]),
            key: category.title,
            onClick: ($event: any) => (_ctx.activecategory = index)
          }, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_ic, {
                icon: category.icon
              }, null, 8, ["icon"])
            ]),
            _createElementVNode("span", {
              class: "titlecategory",
              innerHTML: category.title
            }, null, 8, _hoisted_6)
          ], 10, _hoisted_4))
        }), 128))
      ]),
      _createElementVNode("div", {
        class: "categorydesc",
        innerHTML: _ctx.projects[_ctx.activecategory].description
      }, null, 8, _hoisted_7),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects[_ctx.activecategory].projects, (proj) => {
        return (_openBlock(), _createElementBlock("article", {
          key: proj.title
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("img", {
                src: proj.icon,
                alt: "Project Image"
              }, null, 8, _hoisted_10),
              _createElementVNode("div", {
                class: "name",
                innerHTML: proj.title,
                onClick: ($event: any) => (_ctx.open(proj.github))
              }, null, 8, _hoisted_11)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(proj.langs, (lang) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: lang,
                  class: "lang"
                }, [
                  _createElementVNode("div", {
                    class: "dot",
                    style: _normalizeStyle({ backgroundColor: _ctx.colors[lang] })
                  }, null, 4),
                  _createElementVNode("div", { innerHTML: lang }, null, 8, _hoisted_13)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, _toDisplayString(proj.description), 1),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "links" }, null, -1))
        ]))
      }), 128))
    ]),
    _createVNode(_component_Languages)
  ], 64))
}